/**
 * CreditRemindersBanner — invite le CLIENT à activer les rappels de crédit
 * (nouvelle dette, échéance proche) dans l'app PWA.
 *
 * Ne s'affiche que si le client est rattaché à au moins un carnet de crédit
 * et que les notifications ne sont pas encore autorisées.
 */
import { useEffect, useState } from 'react';
import { useCreditReminders } from '@/hooks/useCreditReminders';
import { notificationsSupported } from '@/lib/pwa';

const DISMISS_KEY = 'zifek-credit-reminders-dismissed';

export default function CreditRemindersBanner() {
  const { hasAccount, permission, enable } = useCreditReminders();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    try {
      setDismissed(localStorage.getItem(DISMISS_KEY) === '1');
    } catch { /* stockage indisponible */ }
  }, []);

  if (!hasAccount || dismissed) return null;
  if (!notificationsSupported()) return null;
  if (permission === 'granted' || permission === 'denied' || permission === 'unsupported') return null;

  const dismiss = () => {
    setDismissed(true);
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch { /* */ }
  };

  return (
    <div className="mx-4 md:mx-6 lg:mx-8 mt-4 flex flex-col sm:flex-row sm:items-center gap-3 bg-accent-50 border border-accent-200/70 rounded-xl px-4 py-3">
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <div className="w-9 h-9 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center flex-shrink-0">
          <i className="ri-notification-3-line"></i>
        </div>
        <div className="min-w-0">
          <p className="text-sm font-semibold text-foreground-900">Activez les rappels de crédit</p>
          <p className="text-xs text-foreground-500 mt-0.5">
            Recevez une notification à chaque nouvelle dette et quand une échéance approche.
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <button
          onClick={enable}
          className="px-4 py-2 rounded-full bg-accent-500 text-background-50 text-xs font-semibold whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
        >
          Activer
        </button>
        <button
          onClick={dismiss}
          className="px-3 py-2 rounded-full text-xs font-medium text-foreground-500 hover:text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          Plus tard
        </button>
      </div>
    </div>
  );
}